export default "__VITE_ASSET__DEBA34fZ__"